import React, { useEffect, useState } from "react";
import { Col, Form, Input, Modal, theme, Row } from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_SKIM } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";

export default function AddPondSkimModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);
  
  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SKIM.SKIM_TRACK}${target.id}/`, data);
      } else {
        await POST(URL_SKIM.SKIM_TRACK, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขลู่ยางสกิม" : "เพิ่มลู่ยางสกิม"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>

      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
            <Form.Item
              label="ชื่อลู่ยางสกิม"
              name="name"
              rules={[{ required: true, message: "กรุณาระบุชื่อลู่ยางสกิม" }]}
            >
              <Input placeholder="ชื่อลู่ยางสกิม"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
